import Mock from 'mockjs'

const {page, save} = require('../util');
const {scores, questions, weights, orgs} = require('./data');
const qs = require('qs');

Mock.mock('/qa/get-all', 'get', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    let rvs = {
        questions: questions,
        scores: scores,
        weights: weights,
        orgs: orgs
    }
    bodyObject.data = rvs;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/qa/get-questions', 'get', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    console.log(JSON.stringify(questions));
    bodyObject.data = questions;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/qa/get-scores', 'get', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    console.log(JSON.stringify(scores));
    bodyObject.data = scores;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/qa/get-weights', 'get', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    console.log(JSON.stringify(weights));
    bodyObject.data = weights;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/qa/get-orgs', 'get', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    console.log(JSON.stringify(orgs));
    bodyObject.data = orgs;
    return {
        code: 200,
        body: bodyObject,
    }
});

